import React, { FC } from 'react'
import SuccessCheck from '../../../lib/util/success-check'

const SuccessMessage = ({ title, subtitle, footer }:{ title: string, subtitle: FC, footer: FC}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="flex items-center flex-col text-center">
        <SuccessCheck />
        <div className="text-gray-800 font-bold my-4">{title}</div>
        {subtitle}
      </div>
      <div className="flex flex-col w-full text-center absolute bottom-4 p-4">{footer}</div>
    </div>
  )
}

export default SuccessMessage
